import { createContext, useContext, useMemo } from "react";
import { useAuth } from "./authContext";

const CurrentUserContext = createContext({
  selectedUserId: null,
  selectedUser: null,
  setSelectedUserId: () => {}
});

export function CurrentUserProvider({ children }) {
  const { user: authenticatedUser } = useAuth();

  const value = useMemo(() => ({
    selectedUserId: authenticatedUser?.id ? Number(authenticatedUser.id) : null,
    selectedUser: authenticatedUser
      ? {
          id: Number(authenticatedUser.id),
          username: authenticatedUser.username || "authenticated-user",
          label: authenticatedUser.username || "Authenticated User"
        }
      : null,
    setSelectedUserId: () => {}
  }), [authenticatedUser]);

  return (
    <CurrentUserContext.Provider value={value}>
      {children}
    </CurrentUserContext.Provider>
  );
}

export function useCurrentUser() {
  return useContext(CurrentUserContext);
}